import LegalPage from "@/pages/LegalPage";

const SECTIONS = [
  {
    title: "Information we collect",
    bullets: [
      "Account and registration details such as your name, email address, phone number, date of birth, gender, city, T-shirt size and blood group.",
      "Emergency contact details you provide for race-day safety.",
      "Profile photos and profile preferences you upload to Fitygrity.",
      "Challenge registrations, participation details, results, leaderboard activity and support enquiries.",
      "Running activity data you choose to sync from Strava or Garmin, including activity date, distance, duration, pace, elevation, heart rate and cadence when available.",
      "Technical information needed to keep you signed in, secure the service and understand how the platform is used.",
    ],
  },
  {
    title: "How we use your information",
    bullets: [
      "Create, verify and secure your athlete account.",
      "Register you for challenges and display verified activity on leaderboards.",
      "Prepare race-kit, emergency and event administration information for authorised Race Control users.",
      "Respond to coaching, travel, event and support enquiries.",
      "Publish articles, stories and other community content you choose to submit.",
      "Improve platform reliability, prevent misuse and meet legal or accounting obligations.",
    ],
  },
  {
    title: "Connected fitness services",
    paragraphs: [
      "If you connect Strava or Garmin, we access only the activity information needed for challenge verification, leaderboards and your running history. You can disconnect a provider at any time through the relevant provider or by contacting us. Provider availability and metric detail depend on your device, privacy settings and the data the provider makes available.",
    ],
  },
  {
    title: "How we share information",
    paragraphs: [
      "We do not sell your personal information. We share limited information with service providers that help us host the platform, store files, send email, process challenge administration and provide analytics. We may disclose information where required by law, to protect athletes and users, or in connection with a business transfer.",
      "Public challenge leaderboards may show your name, challenge progress and activity verification status. Private profile fields such as phone number, emergency contact, blood group and full activity credentials are not public.",
    ],
  },
  {
    title: "Cookies and local storage",
    paragraphs: [
      "We use cookies and browser storage to keep you signed in, remember challenge registration state, improve performance and understand basic product usage. You can control cookies through your browser settings, but some sign-in and challenge features may stop working if storage is disabled.",
    ],
  },
  {
    title: "Data retention and security",
    paragraphs: [
      "We keep personal information only for as long as needed to operate your account, administer events, meet legal obligations and resolve disputes. Verification codes and OAuth state records expire automatically. We use administrative and technical safeguards appropriate to the sensitivity of the information, but no online service can guarantee absolute security.",
    ],
  },
  {
    title: "Your choices and rights",
    bullets: [
      "Review and update your profile from your athlete dashboard.",
      "Sign out of your account at any time.",
      "Disconnect Strava or Garmin and stop future syncing.",
      "Request access, correction or deletion of your personal information by emailing info@fitygrity.com.",
    ],
  },
  {
    title: "Children",
    paragraphs: [
      "Fitygrity accounts are intended for users aged 18 or older. We do not knowingly collect account registration information from children. If you believe a child has created an account, contact info@fitygrity.com.",
    ],
  },
  {
    title: "Changes to this policy",
    paragraphs: [
      "We may update this Privacy Policy as the platform changes. The latest version will always be posted on this page with its updated date. Material changes may also be communicated by email or through the platform.",
    ],
  },
  {
    title: "Contact us",
    paragraphs: [
      "Fitygrity Private Limited operates fitygrity.com. For privacy questions, requests or concerns, email info@fitygrity.com.",
    ],
  },
];

export default function PrivacyPolicy() {
  return (
    <LegalPage
      testId="privacy-policy-page"
      eyebrow="Legal"
      title="Privacy Policy"
      updated="October 7, 2026"
      intro="This policy explains what Fitygrity collects, why we use it, and the choices athletes and visitors have when using fitygrity.com."
      sections={SECTIONS}
    />
  );
}
